import { DateTime } from 'luxon'

export const setTimeToDayEnd = (params: { dateString?: string, inputFormat?: string, outputFormat?: string }) => {
  const { dateString, inputFormat = 'yyyy-MM-dd', outputFormat = "yyyy-MM-dd'T'HH:mm" } = params

  if (!dateString) return null

  const dateTime = DateTime.fromFormat(dateString, inputFormat).endOf('day')

  return dateTime.toFormat(outputFormat)
}

export default setTimeToDayEnd
